// ValuesSection.jsx
import React from 'react';
import './ValuesSection.css';

export default function ValuesSection() {
  const values = [
    {
      title: "Quality Craftsmanship",
      description: "We never compromise on quality. Every nail, every beam, every detail matters in creating structures that last generations."
    },
    {
      title: "Sustainable Solutions",
      description: "We're committed to environmentally responsible building practices that minimize impact while maximizing efficiency."
    },
    {
      title: "Client Partnership",
      description: "We believe in collaborative relationships with our clients, working together to bring visions to life exactly as imagined."
    }
  ];

  return (
    <div className="values-section">
      <div className="container">
        <h2 className="values-heading">Our Values</h2>
        <div className="values-grid">
          {values.map((value, index) => (
            <div className="value-card" key={index}>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}